import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { auth } from "../../backend/firebaseConfig";
import Sidebar from "../DesignSystem/Sidebar";
import "../../css/Departments/DepartmentPage.css";
import { getDepartmentGreetingDataFromTimestamp } from "./utils/departmentGreetingHelpers";
import { useServerSyncedTime } from "../../utils/useServerSyncedTime";
import {ReactComponent as ArrowRight} from "../../assets/icons/financialPromotions/ArrowRight.svg";

const DepartmentPage = ({ title, cards = [] }) => {
  const navigate = useNavigate();

  const { effectiveTimestamp } = useServerSyncedTime();

  const { greeting, formattedDateTime } =
    getDepartmentGreetingDataFromTimestamp(
      effectiveTimestamp,
      auth.currentUser || {},
    );

  return (
    <div className="Main-Page">
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content={`Open the ${title} department page.`}
        />
      </Helmet>

      <Sidebar />

      <div className="Main-Container">
        <div className="department-hero">
          <div className="department-bubbles">
            <span className="department-bubble bubble-1" />
            <span className="department-bubble bubble-2" />
            <span className="department-bubble bubble-3" />
            <span className="department-bubble bubble-4" />
            <span className="department-bubble bubble-5" />
            <span className="department-bubble bubble-6" />
            <span className="department-bubble bubble-7" />
          </div>

          <div className="department-page-header">
            <div className="department-hero-layout">
              <div className="department-greeting-wrap">
                <div className="FP_H2 text-white">{greeting}</div>
              </div>

              <div className="department-info-stack">
                <div className="department-title-chip">
                  <div className="department-date-value">
                    {formattedDateTime}
                  </div>
                </div>

                <div className="department-title-chip">
                  <div className="department-date-value">{title}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="department-card-grid">
          {cards.map((card) => (
            <div
              key={card.route}
              className="department-card"
              onClick={() => navigate(card.route)}
            >
              {card.icn ? (
                <div className="department-card-icon">
                  <card.icn />
                </div>
              ) : null}

              <div className="FP_Subtitle_Semibold">{card.label}</div>

              <div className="FP_Content primary-text">{card.description}</div>

              <div className="department-card-arrow">
                <ArrowRight />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DepartmentPage;
